// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bdX3","rootMobile":"styles_rootMobile__2O2Rj"};